module.exports = __webpack_public_path__ + "img/icon-account-payment-methods-green@3x.357ffdef.png";